<div class="d-flex justify-content-between align-items-end p-4">
  <div>
    <p class="fw-bold">{{ 'user.filterByPermission' | translate }}</p>
    <base-filter-buttons
      selectedClass="btn-dark"
      [activeFilter]="selectedFilter"
      (activeFilterUpdate)="onSelectUserGroup($event)"
    ></base-filter-buttons>
  </div>
  <div class="d-flex flex-wrap gap-2 justify-content-end">
    <base-button
      [size]="buttonSizes.xs"
      [iconSize]="buttonSizes.xs"
      (btnClick)="openEditGroupModal()"
      color="primary"
      icon="fa-solid fa-pen"
      label="user.editPermissionGroup"
    ></base-button>
    <base-button
      [size]="buttonSizes.xs"
      [iconSize]="buttonSizes.xs"
      (btnClick)="openAddGroupModal()"
      color="primary"
      icon="fa-solid fa-plus"
      label="user.addPermissionGroup"
    ></base-button>
  </div>
</div>

<ng-template #addPermissionGroupTemplate>
  <base-add-permission-group-modal
    [modalRef]="modalRef"
    [permissions]="permissionsWithPriorities"
  ></base-add-permission-group-modal>
</ng-template>

<ng-template #editPermissionGroupTemplate>
  <base-edit-permission-groups-form
    class="edit-permission-group"
    [permissions]="permissionsWithPriorities"
    (updateGroup)="updatePermissionGroup($event)"
  ></base-edit-permission-groups-form>
</ng-template>
